export const tdStyle = "py-3 text-sm text-gray-500 mb-8 ";
